import {
    batch } from "react-redux";
import { calculateBillTotal } from "../../utilities/billCalculatorUtils";
import { getConfigValueByKey } from "../../utilities/commonUtilities";
import {
  PARTILBILLAUDIT,
  PayMedium
} from "../../constants/constant";
import { updateAllBillData } from "../billDetailsSlice";

export const recalculateBillTotal =
  ({
    prevTotalPrice = 0.0,
    newTotalPrice = 0.0,
    cgstRate = 0.0,
    sgstRate = 0.0,
    shouldClearPaymentDetails = true,
  } = {}) =>
  (dispatch, getState) => {
    const state = getState();
    // ;
    // Access billPaymentDetails nested inside bill
    const billPaymentDetails = state.bill?.billPaymentDetails || {};
    const pointRedeem = 0.0; // To be fetched from state
    // Destructure necessary values from billPaymentDetails
    const {
      totalPrice,
      cgst,
      sgst,
      isGstAllowed,
      offerType,
      offerValue,
      deliveryCharge,
      isCashPayEnabled,
      isOnlinePayEnabled,
      onlinePay,
      cashPay,
      payMedium,
      cashPayThrough,
      onlinePayThrough,
      onlinePayMedium
    } = billPaymentDetails;
    const isPartialBillEnabled = getConfigValueByKey(
      state.restoBillConfig,
      PARTILBILLAUDIT
    );
    const billTotalSummary = calculateBillTotal({
      prevTotalPrice,
      newTotalPrice,
      billTotalPrice: totalPrice,
      cgstRate: cgstRate === 0.0 ? cgst : cgstRate,
      sgstRate: sgstRate === 0.0 ? sgst : sgstRate,
      pointRedeem,
      isGstAllowed,
      deliveryCharge,
      offerType,
      offerValue,
      isPartialBillEnabled,
    });
    console.log("billTotalSummary", billTotalSummary);
    console.log("billPaymentDetails", billPaymentDetails, shouldClearPaymentDetails);
    
    batch(() => {
      dispatch(
        updateAllBillData({
          //   billDetails: {
          //     pointRedeem: billSummary.pointRedeem,
          //     isPointAdded: billSummary.pointRedeem > 0.0,
          //   }, //TBD
          billPaymentDetails: {
            totalPrice: billTotalSummary.totalPrice.toFixed(2),
            cgst: cgstRate === 0.0 ? cgst : cgstRate,
            sgst: sgstRate === 0.0 ? sgst : sgstRate,
            cgstAmt: billTotalSummary.cgstAmount.toFixed(2),
            sgstAmt: billTotalSummary.sgstAmount.toFixed(2),
            finalPrice: billTotalSummary.finalPrice.toFixed(2),
            roundOff: billTotalSummary.roundOff.toFixed(2),
            payMedium: shouldClearPaymentDetails ? PayMedium.NOPAY : payMedium,
            cashTender: 0,
            cashReturn: 0,
            onlinePayMedium: shouldClearPaymentDetails ? "" : onlinePayMedium,
            isOnlinePayEnabled: shouldClearPaymentDetails ? false : isOnlinePayEnabled ,
            isCashPayEnabled: shouldClearPaymentDetails ? false : isCashPayEnabled,
            onlinePayThrough: shouldClearPaymentDetails ? "" : onlinePayThrough,
            onlinePay: shouldClearPaymentDetails ? 0.0 : onlinePay,
            cashPay: shouldClearPaymentDetails ? 0.0 : cashPay,
            cashPayThrough: shouldClearPaymentDetails ? "" : cashPayThrough,
          },
          billPartialPaymentDetails: {
            duesAmt: billTotalSummary.duesAmount.toFixed(2),
          },
        })
      );
    });
  };
